import {createSlice} from "@reduxjs/toolkit";

const ui = createSlice({
  name: 'ui',
  initialState: {
    rightOffcanvasOpen: false,
    sharedMemberCanvasOpen: false,
    guestSignupModal: false,
    guestSignupPopupOpenedFrom: '',
    resetPasswordPopup: false,
    showVerifyEmailPopup: false,
    segmentData: null,
    chooseYourOrgModal:null,
    assignEditorModal:false,
    triggerBackgroundUploadProcess: false,
  },
  reducers: {
    setRightOffcanvasOpen: (state, { payload }) => {
      state.rightOffcanvasOpen = payload;
    },
    setSharedMemberCanvasOpen: (state, { payload }) => {
      state.sharedMemberCanvasOpen = payload;
    },
    setSignupPopOpen: (state, { payload }) => {
      state.guestSignupModal = payload;
    },
    setSignupPopOpenedFrom: (state, { payload }) => {
      state.guestSignupPopupOpenedFrom = payload;
    },
    setResetPasswordPopupOpen: (state, { payload }) => {
      state.resetPasswordPopup = payload;
    },
    setShowVerifyEmailPopup: (state, { payload }) => {
      state.showVerifyEmailPopup = payload;
    },
    setSegmentData: (state, { payload }) => {
      state.segmentData = payload;
    },
    setChooseYourOrgPopOpen: (state, { payload }) => {
      state.chooseYourOrgModal = payload;
    },
    setAssignEditorPopOpen: (state, { payload }) => {
      state.assignEditorModal = payload;
    },
    setTriggerBackgroundUploadProcess: (state, { payload }) => {
      state.triggerBackgroundUploadProcess = payload;
    },
  },
});

export const {
  setRightOffcanvasOpen,
  setSharedMemberCanvasOpen,
  setSignupPopOpen,
  setResetPasswordPopupOpen,
  setShowVerifyEmailPopup,
  setSegmentData,
  setChooseYourOrgPopOpen,
  setSignupPopOpenedFrom,
  setAssignEditorPopOpen,
  setTriggerBackgroundUploadProcess,
} = ui.actions;
export const uiSelector = (state) => state.ui;
export const uiReducer = ui.reducer;
export default uiReducer;

export const selectTeamMembersFilterOpen = (state) => uiSelector(state).rightOffcanvasOpen;
export const selectSharedMembersFilterOpen = (state) => uiSelector(state).sharedMemberCanvasOpen;
export const selectSignupPopOpen = (state) => uiSelector(state).guestSignupModal;
export const selectResetPopOpen = (state) => uiSelector(state).resetPasswordPopup;

export const selectShowVerifyEmailPopup = (state) => uiSelector(state).showVerifyEmailPopup;
export const selectSegmentData = (state) => uiSelector(state).segmentData

export const selectChooseYourOrgPopOpen = (state) => uiSelector(state).chooseYourOrgModal;
export const selectSignupPopOpenedFrom = (state) => uiSelector(state).guestSignupPopupOpenedFrom;
export const selectAssignEditorPopOpen = (state) => uiSelector(state).assignEditorModal;
export const selectTriggerBackgroundUploadProcess = (state) =>
  uiSelector(state).triggerBackgroundUploadProcess;
